export default __webpack_public_path__ + "static/media/arrow6.b24dae33.png";